import React from "react";
import { Btn } from "./primitives";
import { Copy, Trash, X, ArrowCounterClockwise, FilePdf } from "@phosphor-icons/react";

export default function BulkActionBar({ count, onClear, onCopy, onDelete, onRestore, onBundle, lang = "de", deleteLabel }) {
  if (!count) return null;
  const selected = lang === "de" ? `${count} ausgewählt` : `${count} selected`;
  return (
    <div className="sticky top-2 z-20 mb-4 flex flex-wrap items-center gap-2 swiss-card px-4 py-2 border-[var(--brand)]"
      data-testid="bulk-action-bar">
      <button onClick={onClear} data-testid="bulk-clear" className="text-[var(--muted)] hover:text-[var(--ink)] mr-2">
        <X size={16} />
      </button>
      <span className="text-sm font-medium text-[var(--ink)]">{selected}</span>
      <div className="flex gap-2 ml-auto">
        {onBundle && (
          <Btn variant="secondary" onClick={onBundle} data-testid="bulk-bundle" className="h-8">
            <FilePdf size={14} /> {lang === "de" ? "PDF-Bundle" : "PDF bundle"}
          </Btn>
        )}
        {onCopy && (
          <Btn variant="secondary" onClick={onCopy} data-testid="bulk-copy" className="h-8">
            <Copy size={14} /> {lang === "de" ? "Kopieren" : "Copy"}
          </Btn>
        )}
        {onRestore && (
          <Btn variant="secondary" onClick={onRestore} data-testid="bulk-restore" className="h-8">
            <ArrowCounterClockwise size={14} /> {lang === "de" ? "Wiederherstellen" : "Restore"}
          </Btn>
        )}
        {onDelete && (
          <Btn variant="danger" onClick={onDelete} data-testid="bulk-delete" className="h-8">
            <Trash size={14} /> {deleteLabel || (lang === "de" ? "Löschen" : "Delete")}
          </Btn>
        )}
      </div>
    </div>
  );
}

export function Checkbox({ checked, onChange, testId }) {
  return (
    <input
      type="checkbox"
      checked={!!checked}
      onChange={(e) => onChange(e.target.checked)}
      data-testid={testId}
      className="w-4 h-4 rounded-sm border border-[var(--border-strong)] text-[var(--brand)] focus:ring-2 focus:ring-[var(--brand-soft)] accent-[var(--brand)] cursor-pointer"
      onClick={(e) => e.stopPropagation()}
    />
  );
}
